// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/LegalPage.css */
.legal-page {
    background: linear-gradient(to bottom right, #f0f9ff, #e0f2fe);
    min-height: 100vh;
    padding: 6rem 1rem;
    font-family: 'Poppins', sans-serif;
  }
  
  .legal-container {
    max-width: 800px;
    margin: 0 auto;
    background: white;
    padding: 3rem;
    border-radius: 16px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05);
  }
  
  .legal-container h1 {
    font-size: 2.5rem;
    color: #1e293b;
    margin-bottom: 1rem;
  }
  
  .legal-container h2 {
    font-size: 1.5rem;
    color: #2563eb;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
  
  .legal-container h3 {
    font-size: 1.25rem;
    color: #1e293b;
    margin-top: 1.5rem;
  }
  
  .legal-container p {
    color: #475569;
    line-height: 1.6;
    margin-bottom: 1rem;
  }
  
  .legal-container ul {
    margin-left: 1.5rem;
    margin-bottom: 1.5rem;
  }
  
  .legal-container li {
    margin-bottom: 0.5rem;
    color: #475569;
  }
  
  .legal-container a {
    color: #2563eb;
    text-decoration: none;
    font-weight: 500;
  }
  
  .legal-container a:hover {
    text-decoration: underline;
  }
  
  @media (max-width: 768px) {
    .legal-page {
      padding: 4rem 1rem;
    }
    
    .legal-container {
      padding: 2rem;
    }
    
    .legal-container h1 {
      font-size: 2rem;
    }
    
    .legal-container h2 {
      font-size: 1.3rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/LegalPage.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,8DAA8D;IAC9D,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;EACF","sourcesContent":["/* src/pages/LegalPage.css */\n.legal-page {\n    background: linear-gradient(to bottom right, #f0f9ff, #e0f2fe);\n    min-height: 100vh;\n    padding: 6rem 1rem;\n    font-family: 'Poppins', sans-serif;\n  }\n  \n  .legal-container {\n    max-width: 800px;\n    margin: 0 auto;\n    background: white;\n    padding: 3rem;\n    border-radius: 16px;\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05);\n  }\n  \n  .legal-container h1 {\n    font-size: 2.5rem;\n    color: #1e293b;\n    margin-bottom: 1rem;\n  }\n  \n  .legal-container h2 {\n    font-size: 1.5rem;\n    color: #2563eb;\n    margin-top: 2rem;\n    margin-bottom: 1rem;\n  }\n  \n  .legal-container h3 {\n    font-size: 1.25rem;\n    color: #1e293b;\n    margin-top: 1.5rem;\n  }\n  \n  .legal-container p {\n    color: #475569;\n    line-height: 1.6;\n    margin-bottom: 1rem;\n  }\n  \n  .legal-container ul {\n    margin-left: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  .legal-container li {\n    margin-bottom: 0.5rem;\n    color: #475569;\n  }\n  \n  .legal-container a {\n    color: #2563eb;\n    text-decoration: none;\n    font-weight: 500;\n  }\n  \n  .legal-container a:hover {\n    text-decoration: underline;\n  }\n  \n  @media (max-width: 768px) {\n    .legal-page {\n      padding: 4rem 1rem;\n    }\n    \n    .legal-container {\n      padding: 2rem;\n    }\n    \n    .legal-container h1 {\n      font-size: 2rem;\n    }\n    \n    .legal-container h2 {\n      font-size: 1.3rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
